import { Component, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
  selector: 'widgets-column',
  // <div [ngClass]="coldef()"><ng-template #container></ng-template></div>
  //template: `<ng-template #container></ng-template>`,
  templateUrl: 'widgets-column.template.html'
})
export class widgetsColumn {
  @ViewChild('container', { read: ViewContainerRef, static: true })
  public container: ViewContainerRef;

  public columnsCount: number;

  // coldef(): string {
  //   return "col-12 col-md-" + (12 / this.columnsCount);
  //   //return 'col-sm';
  // }
}
